
function initProductBundle(container) {
  const form = container.closest('form');
  const variantInput = form ? form.querySelector('[data-bundle-variant-input]') : null;
  const checkboxes = container.querySelectorAll('[data-pb-checkbox]');
  const totalElement = container.querySelector('[data-pb-total]');
  const buttonText = container.querySelector('[data-pb-button-text]');
  const buttonTemplate = container.dataset.pbButtonText;
  const addButton = container.querySelector('.pb-add-to-cart');

  function formatMoney(cents) {
    const format = container.dataset.shopMoneyFormat;
    const amount = (cents / 100).toFixed(2);
    const parts = amount.split('.');
    const dollars = parts[0];
    const cents_part = parts[1];
    const formattedAmount = `${dollars}.<sup>${cents_part}</sup>`;
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    return format.replace(placeholderRegex, formattedAmount);
  }

  function updateTotal() {
    let total = 0;
    let count = 0;
    const selectedVariantIds = [];
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        const item = checkbox.closest('[data-pb-item]');
        const price = parseInt(item.dataset.price);
        const variantId = item.dataset.variantId;
        total += price;
        count++;
        selectedVariantIds.push(variantId);
      }
    });
    if (variantInput) {
      variantInput.value = selectedVariantIds.join(',');
    }
    totalElement.innerHTML = formatMoney(total);
    if (count === 0) {
      buttonText.textContent = 'No products selected';
    } else {
      buttonText.textContent = buttonTemplate.replace('[count]', count);
    }
  }

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', updateTotal);
  });

  updateTotal();

  if (addButton && window.location.pathname.indexOf('/cart') !== -1) {
    addButton.addEventListener('click', function(e) {
      e.preventDefault();
      let selectedVariants = [];
      checkboxes.forEach((checkbox) => {
        if (checkbox.checked) {
          const item = checkbox.closest('[data-pb-item]');
          selectedVariants.push(item.dataset.variantId);
        }
      });
      if (selectedVariants.length === 0) return;
      addButton.disabled = true;
      addButton.classList.add('loading');
      let addCount = 0;
      let errors = 0;
      selectedVariants.forEach((variantId) => {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then((response) => {
          if (!response.ok) errors++;
          addCount++;
          if (addCount === selectedVariants.length) {
            addButton.disabled = false;
            addButton.classList.remove('loading');
            if (errors === 0) {
              buttonText.textContent = 'Added!';
              setTimeout(updateTotal, 1200);
              window.location.reload();
            } else {
              buttonText.textContent = 'Error adding products';
              setTimeout(updateTotal, 2000);
            }
          }
        })
        .catch(() => {
          errors++;
          addCount++;
          if (addCount === selectedVariants.length) {
            addButton.disabled = false;
            addButton.classList.remove('loading');
            buttonText.textContent = 'Error adding products';
            setTimeout(updateTotal, 2000);
          }
        });
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const pbContainers = document.querySelectorAll('[data-pb-products]');
  pbContainers.forEach((container) => {
    initProductBundle(container.closest('.pb-container'));
  });
});
